 <template>
  <div style="height:100%">
    <!-- 表格 -->
    <div style="height:82%;background-color:#fff;border-radius:8px;padding: 20px">
      <el-button type="primary" size="small" style="margin-bottom:20px" @click="add">新增</el-button>
      <el-table :data="tableData" stripe height="80%" size="small" :header-cell-style="{'background-color':'#344158cc','color':'#fff','text-align':'center'}" :cell-style="{'text-align':'center'}">
        <el-table-column prop="imagePath" label="合作伙伴图" width="100px">
          <template v-slot:default="scope">
            <el-image :src="'/api/file/check-image?filePath='+scope.row.imagePath" :preview-src-list="getImageUrlList(scope.row.imagePath)" style="height: 35px;width: 70px;margin-top: 7px"/>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="80px">
          <template scope="scope">
            <el-row>
              <el-col :span="12">
                <el-tooltip effect="dark" content="编辑" placement="top-end">
                  <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="edit(scope.row)"></el-button>
                </el-tooltip>
              </el-col>
              <el-col :span="12">
                <el-tooltip effect="dark" content="删除" placement="top-end">
                  <el-popconfirm title="确认删除吗？" @confirm="delSubMit(scope.row)">
                    <el-button content="删除" slot="reference" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding-top:20px;height:40px;background-color:#fff;width: 100%;border-radius:8px;text-align:right">
        <el-pagination background layout="total,prev,pager,next" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <!-- 弹出层 -->
    <el-dialog title="新增" :visible.sync="dialogFormAdd" width="800px" :close-on-click-modal="false">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:500px">
          <el-form-item label="合作伙伴图" prop="imagePath">
            <el-upload
                action="#"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="imageChange">
              <img v-if="tempImagePath" :src="tempImagePath" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormAdd = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹出层 -->
    <el-dialog title="编辑" :visible.sync="dialogFormEdit" width="800px" :close-on-click-modal="false">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:500px">
        <el-form-item label="合作伙伴图" prop="imagePath">
          <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="imageChange">
            <img v-if="tempImagePath" :src="tempImagePath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormEdit = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="editSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkImage = (rule, value, callback) => {
      if (!this.addParams.imagePath) {
        return callback(new Error('图片不能为空'));
      }else {
        return callback();
      }
    };
    return {
      path:'/y-partners-info',
      total: 0,
      tableData: [],
      dialogFormAdd: false,
      dialogFormEdit: false,
      addParams: {
        id:"",
        imagePath:"",
      },
      rules: {
        imagePath:[
          { required: true, validator:checkImage, trigger: 'change' }
        ],
      },
      tempImagePath:'',
      categoryList:[],
    };
  },
  created() {
    this.list()
  },
  methods:{
    list() {
      this.axios({
        method: "get",
        url: this.path+"/list"
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    add(){//新增弹出层
      this.tempImagePath=""
      this.dialogFormAdd = true;
      this.addParams = {};
    },
    edit(row){//编辑弹出层
      this.addParams = row;
      this.tempImagePath = "/api/file/check-image?filePath="+this.addParams.imagePath
      this.dialogFormEdit = true;
    },
    addSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }else {
          this.axios({
            method: "post",
            url: this.path+"/add",
            data: this.addParams,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.dialogFormAdd = false;
              this.$message({message: "添加成功",type: "success"});
              this.list();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    editSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }else {
          this.axios({
            method: "post",
            url: this.path+"/update",
            data: this.addParams,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({message: "修改成功",type: "success"});
              this.list();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    delSubMit(row){//删除
      this.axios({
        method: "delete",
        url: this.path+"/delete",
        params: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({message: "删除成功",type: "success"});
          this.list();
        }else{
          this.$message({type:"error",message: res.data.message});
        }
      });
    },
    onSearch(){
      this.list();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.list();
    },
    imageChange(file){
      let obj = {}
      obj.name = file.name
      let param = new FormData(); //创建form对象
      param.append('file',file.raw);
      this.axios({
        method:"post",
        url:"/file/upload",
        data:param
      }).then((res)=>{
        let filePath = res.data.data.filePath
        this.addParams.imagePath = filePath
        this.tempImagePath = "/api/file/check-image?filePath="+filePath
        this.$refs['addParams'].validateField('imagePath');
      })
    },
    getImageUrlList(path){
      let images = []
      images.push("/api/file/check-image?filePath="+path)
      return images;
    },
  }
};
</script>

<style>

</style>